import { render, staticRenderFns } from "./AppSystemInfoCard.vue?vue&type=template&id=ed7eb7d4&"
import script from "./AppSystemInfoCard.vue?vue&type=script&lang=ts&"
export * from "./AppSystemInfoCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports